module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('button', {
    staticClass: "fl-button",
    staticStyle: {
      "width": "100%",
      "margin": "0 5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setupDownload()
      }
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('h1', [_vm._v("Üdvözöljük")]), _vm._v(" "), _c('div', {
    staticClass: "normal-text"
  }, [_vm._v("\n          A rendszer használatához válasszon a bal oldali menüpontok közül!\n        ")]), _vm._v(" "), _c('h2', [_vm._v("Önállóan üzemelő nciom alapú beléptető rendszerek (kizárólag egyetemi hálózatból érhetők el)")]), _vm._v(" "), _vm._m(1)])])], 1), _vm._v(" "), _c('HTMLFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-download"
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Montserrat'",
      "padding-left": "5px",
      "font-size": "15px"
    }
  }, [_vm._v("Kártyaolvasó illesztő letöltése")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Név")]), _vm._v(" "), _c('th', [_vm._v("Cím")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("D711")]), _vm._v(" "), _c('td', [_vm._v("d711-belepteto.sze.hu")]), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "small-button",
    attrs: {
      "href": "http://d711-belepteto.sze.hu",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fas fa-forward",
    staticStyle: {
      "font-size": "18px",
      "cursor": "pointer"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5620d7ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/home.vue
// module id = 301
// module chunks = 0